import React from 'react';

import Button from "../../../Common/Button";
import Icon from "../../../Common/Icon";
import InputSelect from '../../../FormFields/Select';
import Condition from '../../../../Models/FieldCondition';
import withFieldActions from '../withFieldActions';

import FormContextProvider, { FormContext } from '../../../../Context/FormContext';

import ConditionalFields from '../../../../Services/ConditionalFields';
import Utils from '../../../../Services/Utils';
import ConfigService from "../../../../Services/api/Config";
import {ReactComponent as DeleteIcon} from "../../../../../img/icon-delete.svg";
import {ReactComponent as OpenIcon} from "../../../../../img/expand-closed.svg";
import {ReactComponent as EditIcon} from "../../../../../img/icon-template-edit.svg";

function withConditions(WrappedComponent, selectData) {

  return class extends withFieldActions(WrappedComponent, selectData) {

    removeCondition = (index) => {
      const { internalField } = this.state;
      internalField.conditions.splice(index, 1);
      this.setState({ internalField: { ...internalField } });
    };

    addOrEditCondition = (condition, editingIndex) => {
      this.setState({
        currentConditionView: 1,
        currentCondition: condition,
      });
      if (editingIndex !== undefined) this.editingIndex = editingIndex;
      else this.editingIndex = -1;
    };

    submitCondition = () => {
      const { internalField, currentCondition } = this.state;
      const index = this.editingIndex;
      if (index !== -1) internalField.conditions[index] = new Condition(currentCondition);
      else internalField.conditions = [...internalField.conditions, new Condition(currentCondition)];
      this.setState({
        internalField: { ...internalField, conditions: [...internalField.conditions] },
        currentConditionView: 0,
        currentCondition: null,
      });
      this.editingIndex = -1;
    };


    _getValueLabel = (value) => {
      if (Utils.isNull(value)) return value;
      let result = null;
      if (Array.isArray(value)) {
        let arrayValues = [];
        value.forEach((item) => {
          if (item.label) {
            arrayValues.push(item.label);
          }
          else {
            arrayValues.push(item.value ? item.value : item);
          }
        });
        result = arrayValues.join(',');
      }
      else {
        if (value.label) {
          result = value.label;
        }
        else {
          result = (value.value ? value.value : value);
        }
      }
      return result;
    };

    _isFieldComponent = (field) => {
      switch (field.component) {
        case 'fileInput':
        case 'imageInput':
        case 'imageMultipleInput':
        case 'signatureInput':
        case 'freeText':
        case 'fileEmbedded':
          return true;
        default:
          return false;
      }
    };

    cancelCondition = () => {
      this.setState({
        currentConditionView: 0,
        currentCondition: null,
      });
      this.editingIndex = -1;
    };

    changeConditionData = (field, value) => {
      const { currentCondition } = this.state;
      if (field === 'conditionField') {
        currentCondition['conditionType'] = null;
        currentCondition.errors['conditionType'] = 'This field is required';
        currentCondition['conditionValue'] = null;
        currentCondition.errors['conditionValue'] = 'This field is required';
      }
      if (field === 'conditionType' && (value.value === 'Empty' || value.value === 'Not Empty' || value.value === 'Is Empty' || value.value === 'Is Not Empty')) {
        delete currentCondition.errors['conditionValue'];
      }
      currentCondition[field] = value;
      this.setState({
        currentCondition: { ...currentCondition },
      });
    };

    changeConditionError = (field, value) => {
      const { currentCondition } = this.state;
      currentCondition.errors[field] = value;
      this.setState({
        currentCondition: { ...currentCondition },
      });
    };

    renderConditionsTab = () => {
      const { currentConditionView } = this.state;
      switch (currentConditionView) {
        case 0:
          return this.renderAddCondition();
        case 1:
          return this.renderDisplayCondition();
      }
    };

    renderDisplayCondition = () => {
      const { api } = this.props;
      const { currentCondition, internalField } = this.state;
      const conditionFields = api.getValidFieldsForConditions(internalField.id, false);
      return (
        <FormContextProvider>
          <FormContext.Consumer>
            { context => (
              <div className='Condition_Form'>
                <InputSelect label='Show this field when...' required value={ currentCondition.conditionField }
                             options={ conditionFields.map(
                               option => {return { label: option.label, value: option.id };}) }
                             error={ currentCondition.errors['conditionField'] }
                             onError={ (error) => this.changeConditionError('conditionField', error) }
                             onChange={ (v) => this.changeConditionData('conditionField', v) }/>
                { currentCondition.conditionField && (
                  <InputSelect label='Condition...' placeholder='No condition' required value={ currentCondition.conditionType }
                               options={ ConditionalFields.getOptions(
                                 conditionFields.find(item => item.id === currentCondition.conditionField.value)) }
                               error={ currentCondition.errors['conditionType'] }
                               onError={ (error) => this.changeConditionError('conditionType', error) }
                               onChange={ (v) => this.changeConditionData('conditionType', v) }/>
                ) }
                { currentCondition.conditionType && (
                  ConditionalFields.getValueInput(
                    conditionFields.find(item => item.id === currentCondition.conditionField.value),
                    (v) => this.changeConditionData('conditionValue', v),
                    (error) => this.changeConditionError('conditionValue', error),
                    currentCondition,
                  )
                ) }
                <div className='Condition_Form_Footer'>
                  <Button className='Button Button_Small'
                          onClick={ () => context.submit(this.submitCondition, currentCondition.errors) }>Save
                  </Button>
                  <Button className='Button Button_Small Button_Cancel'
                          onClick={ () => context.cancel(this.cancelCondition) }>Cancel
                  </Button>
                </div>
              </div>
            ) }
          </FormContext.Consumer>
        </FormContextProvider>
      );
    };

    renderConditionItem = (item, index) => {
      let value = this._getValueLabel(item.conditionValue);
      const styleTitle = {
        'color': ConfigService.getColor('primaryColor')
      };
      return (
        <li className='Condition_Item' key={ index } style={ styleTitle }>
          <div className='Condition_Item_Text'>
            { item.conditionField.label } { item.conditionType.label } <span className='Bold'>{ value }</span>
          </div>
          <div className='Condition_Item_Actions'>
            <div className='Condition_Item_Actions_Edit' onClick={ () => this.addOrEditCondition(item, index) }>
              <Icon width='16' height='16' color='secondaryColor'>
                <EditIcon alt='icon-template-edit'/>
              </Icon>
            </div>
            <div className='Condition_Item_Actions_Remove' onClick={ () => this.removeCondition(index) }>
              <Icon width='17' height='18' color='secondaryColor'>
                <DeleteIcon alt='icon-delete'/>
              </Icon>
            </div>
          </div>
        </li>
      );
    };

    renderAddCondition = () => {
      const { api } = this.props;
      const { internalField } = this.state;
      const conditionFields = api.getValidFieldsForConditions(internalField.id, false);
      return (
        <div className='Widget_Form_Conditions'>
          <div className='Conditions_List'>
            Display conditions:
            {internalField.conditions && (internalField.conditions.length > 0) && (
              <ul className='Conditions_List_Inner'>
                {internalField.conditions.map((item, index) => this.renderConditionItem(item, index))}
              </ul>
            )}
            {conditionFields.length > 0 && (
              <div className='Widget_Form_Conditions_Add'
                   onClick={() => this.addOrEditCondition(new Condition())}>Add
                display condition
                <Icon width='15' height='15' color='secondaryColor'>
                  <OpenIcon alt='expand-closed'/>
                </Icon>
              </div>
            ) || (
              <div>Add additional fields to dynamic form before creating a condition</div>
            )}
          </div>
        </div>
      );
    };

    renderForm = (renderConfigTab) => {
      const { internalField } = this.state;
      return (
        <div className='Widget_Form'>
          {renderConfigTab(internalField, this.changeFieldValue, this.changeFieldErrors)}
          <hr/>
          {this.renderConditionsTab()}
        </div>
      );
    };
  };
}

export default withConditions;